<template>
	<footer class="hide-for-print" :class="'footer ' + classN">
		<div class="container" :class="{ animations: !isUp }">
      <span>
        <i class="fa fa-caret-down" v-if="!isUp" @click="forwardChange"></i>
        <i class="fa  fa-caret-up" v-else @click="forwardChange"></i>
      </span>
			<p class="text">
				{{ $t("layout.footer.Copyright") }} © {{ currentYear }}
				{{ $t("layout.footer.walbingMarketplace") }} -
				<b @click="showTermsAndConditions">{{
						$t("layout.footer.Terms")
					}}</b>
				-
				<b><a :href="footerLink.PrivacyPolicy" target="_blank">
					{{ $t("layout.footer.Privacy") }}
				</a></b
				>
				-
				<b><a :href="footerLink.CookiePolicy" target="_blank">
					{{ $t("layout.footer.Cookie") }}
				</a></b>
				-
				<b><a href="#/company-disclosure" target="_blank">{{ $t("layout.footer.Company") }}
				</a></b>
			</p>
		</div>
		<TermsAndConditionsDisplay ref="tosDisplay"></TermsAndConditionsDisplay>
	</footer>
</template>

<script>
import TermsAndConditionsDisplay from "@/components/templates/common/TermsAndConditionsDisplay";
import {localization} from "@/common/lang/localization";
import {enumDef} from "@/common/enumDefs";

export default {
	components: { TermsAndConditionsDisplay },
	props: {
		classN: {
			type: String,
			default: ""
		}
	},
	data() {
		return {
			isUp: true,
			footerLink: {
				PrivacyPolicy: localization.currentLang() == enumDef.language.DE ? `https://walbing.com/de/datenschutz/` : `https://walbing.com/privacy-policy/`,
				CookiePolicy: localization.currentLang() == enumDef.language.DE ? `https://walbing.com/de/cookie-richtlinie/` : `https://walbing.com/cookie-policy/`,
			}
		};
	},
	methods: {
		forwardChange() {
			this.isUp = !this.isUp;
		},
		showTermsAndConditions() {
			this.$refs.tosDisplay.show();
		}
	},
	computed: {
		currentYear() {
			return moment().year();
		}
	}
};
</script>
